module.exports = __webpack_public_path__ + "static/media/connect-calendar.d29fa572.svg";